import { FileText, Globe, Megaphone, Newspaper, Sparkles } from 'lucide-react';

export const PULSE_SOURCE_CONFIG = {
  serff: {
    label: 'SERFF',
    chipLabel: 'SERFF',
    color: 'var(--c-teal-active)',
    softBg: 'rgba(13, 148, 136, 0.1)',
    Icon: FileText,
  },
  pr_news: {
    label: 'News / PR',
    chipLabel: 'News / PR',
    color: 'var(--c-blue-1)',
    softBg: 'rgba(37, 99, 235, 0.1)',
    Icon: Newspaper,
  },
  linkedin_ads: {
    label: 'LinkedIn',
    chipLabel: 'LinkedIn',
    color: 'var(--c-purple-1)',
    softBg: 'rgba(124, 58, 237, 0.1)',
    Icon: Newspaper,
  },
  meta_ads: {
    label: 'Meta',
    chipLabel: 'Meta',
    color: 'var(--c-orange)',
    softBg: 'rgba(234, 88, 12, 0.1)',
    Icon: Megaphone,
  },
  google_ads: {
    label: 'Google',
    chipLabel: 'Google',
    color: '#1a7f4b',
    softBg: 'rgba(26, 127, 75, 0.1)',
    Icon: Globe,
  },
};

export const SOURCE_CHIPS = [
  { label: 'All sources', code: null, color: 'var(--text2)', Icon: Sparkles },
  { label: 'SERFF', code: 'serff', ...PULSE_SOURCE_CONFIG.serff },
  { label: 'News / PR', code: 'pr_news', ...PULSE_SOURCE_CONFIG.pr_news },
  { label: 'LinkedIn', code: 'linkedin_ads', ...PULSE_SOURCE_CONFIG.linkedin_ads },
  { label: 'Meta', code: 'meta_ads', ...PULSE_SOURCE_CONFIG.meta_ads },
  { label: 'Google', code: 'google_ads', ...PULSE_SOURCE_CONFIG.google_ads },
];

export const DISTRIBUTION_SEGMENTS = [
  { code: 'serff', key: 'serff' },
  { code: 'pr_news', key: 'pr_news' },
  { code: 'linkedin_ads', key: 'linkedin_ads' },
  { code: 'meta_ads', key: 'meta_ads' },
  { code: 'google_ads', key: 'google_ads' },
];

export const getSourceConfig = (sourceCode) => (
  PULSE_SOURCE_CONFIG[sourceCode] || {
    label: sourceCode || 'Event',
    color: 'var(--text3)',
    softBg: 'var(--c-gray-1, #f1f5f9)',
    Icon: Sparkles,
  }
);

const AVATAR_HUES = [205, 168, 280, 32, 145, 12];

export const companyInitials = (name) => {
  const raw = String(name || '').trim();
  if (!raw) return '?';
  const parts = raw.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  return raw.slice(0, 2).toUpperCase();
};

export const companyAvatarHue = (name) => {
  const raw = String(name || '').trim();
  let hash = 0;
  for (let i = 0; i < raw.length; i += 1) {
    hash = (hash * 31 + raw.charCodeAt(i)) % 9973;
  }
  return AVATAR_HUES[hash % AVATAR_HUES.length];
};
